import * as z from "zod";

export const verifySignupOtp = {
  name: "verifySignupOtp" as const,
  input: z.object({
    email: z.email(),
    otpId: z.string(),
    passcode: z.string(),
  }),
  output: z.object({
    valid: z.boolean(),
    emailLoginToken: z.string().optional(),
  }),
};
